import { ContainerNode, render } from "preact"
import { BaseComponent } from "utils/base-component"
import { App, IncentiveApp } from "./App"
import { prefetchSupport } from "./hooks/support"

export class SignUp extends BaseComponent {
  init(): void {
    prefetchSupport()

    const incentive = document.querySelectorAll(".js-incentive")
    incentive.forEach((el) => {
      el.replaceChildren("")
      this.incentive(el)
    })

    const els = document.querySelectorAll(".js-premium-modal, .js-sign-up-no-free")
    els.forEach((el) => {
      el.addEventListener("click", (event) => {
        event.preventDefault()

        this.mount()
      })
    })
  }

  private incentive(el: ContainerNode): void {
    render(<IncentiveApp onOpen={() => this.mount()} />, el)
  }

  private mount(): void {
    document.dispatchEvent(new CustomEvent("adbridg:disallowFooter"))
    render(<App close={() => this.close()} />, this.root)

    document.body.style.setProperty("overflow", "hidden")
    document.body.appendChild(this.root)
  }

  private close(): void {
    render(null, this.root)

    document.body.style.removeProperty("overflow")
    document.body.removeChild(this.root)

    document.dispatchEvent(new CustomEvent("adbridg:allowFooter"))
  }
}
